export default __webpack_public_path__ + "static/media/img_03.20d03f88.jpg";